var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9538",
    "data-name": "Group 9538",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 364.871,
    height: 304,
    viewBox: "0 0 364.871 304",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5126",
    "data-name": "Rectangle 5126",
    width: 364.871,
    height: 304,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5077",
    "data-name": "Rectangle 5077",
    width: 364.871,
    height: 25.14,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27419",
    "data-name": "Path 27419",
    d: "M60.532,0V8.247H55.149V89.559L74.78,92.892v6.6H61.791L61.219,209.54l187.1-3.8-7.507-101.56,15.536-3.814V90.934l-13.79-1.519,5.761-77.736h6.791l2.017-9.057Z",
    transform: "translate(-55.149)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.357,
    y1: 1.451,
    x2: -0.35,
    y2: 1.451,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9bdda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#c9bdda"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2dbf7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5080",
    "data-name": "Rectangle 5080",
    width: 98.695,
    height: 209.541,
    fill: "#b59cc2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5081",
    "data-name": "Rectangle 5081",
    width: 169.781,
    height: 15.037,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5082",
    "data-name": "Rectangle 5082",
    width: 159.289,
    height: 4.619,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5083",
    "data-name": "Rectangle 5083",
    width: 188.254,
    height: 8.127,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5084",
    "data-name": "Rectangle 5084",
    width: 86.838,
    height: 3.814,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5085",
    "data-name": "Rectangle 5085",
    width: 142.862,
    height: 38.577,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27426",
    "data-name": "Path 27426",
    d: "M85.639,119.737l47.025,3.852a46.31,46.31,0,0,1,27.491,20.135l103.422-3.675s-7.6-15.784-28.312-20.9Z",
    transform: "translate(-85.639 -119.153)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.629,
    y1: 6.034,
    x2: -0.622,
    y2: 6.034,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd4c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff6d6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5088",
    "data-name": "Rectangle 5088",
    width: 190.279,
    height: 42.645,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27428",
    "data-name": "Path 27428",
    d: "M43.824,212.816l86.938-21.265,109.393.834V163.815L43.649,147.573s-8.925,31.369.175,65.243",
    transform: "translate(-39.733 -147.573)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.228,
    y1: 1.704,
    x2: -0.222,
    y2: 1.704,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#372c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#372c9c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2a0f5b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27429",
    "data-name": "Path 27429",
    d: "M46.883,180.783l.23,8.233,4.142-1.042L53.181,204.2l-3.16.9,67.186-19.057,186.525,1.446V167.725l-182.361-2.773Z",
    transform: "translate(-46.883 -164.952)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.5,
    r: 2.289,
    gradientTransform: "matrix(0.156, 0, 0, -1, -0.201, 4.404)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3e6ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.511,
    stopColor: "#efe4ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.952,
    stopColor: "#e5deed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#e4deed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e4deed"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5093",
    "data-name": "Rectangle 5093",
    width: 95.026,
    height: 47.639,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27430",
    "data-name": "Path 27430",
    d: "M31.169,215.189l.731,18.852,94.3,2.2L124.351,188.6Z",
    transform: "translate(-31.169 -188.597)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -0.429,
    y1: 1.207,
    x2: -0.415,
    y2: 1.207,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ab9ce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.017,
    stopColor: "#ab9ce3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27431",
    "data-name": "Path 27431",
    d: "M31.17,215.187l.729,18.853,94.3,2.2L124.35,188.6Z",
    transform: "translate(-31.17 -188.597)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -0.429,
    y1: 1.207,
    x2: -0.415,
    y2: 1.207,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c5c1d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#a592c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a592c2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27432",
    "data-name": "Path 27432",
    d: "M23.389,214.1l.192,4.967L124,192.337c.566,27.5-2.852,42.5-2.852,42.5l-96.942.471.255,6.557,113.3-.089,184.55-2.439c5.148-28.444-1.911-50.622-1.911-50.622l-196.7-4.095Z",
    transform: "translate(-23.389 -184.623)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -0.101,
    y1: 1.096,
    x2: -0.096,
    y2: 1.096,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a966dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#a966dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8143e5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27433",
    "data-name": "Path 27433",
    d: "M42.19,219.268l77.862-22.877,192.215,3.891V193.37l-191.5-1.6L45.187,213.21s-4.189-38.255,1-61.031l83.571,19.96,182.832,1.666.86-9.2L193.1,150.82,42.19,146.289s-15.518,29.97,0,72.979",
    transform: "translate(-35.293 -146.289)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -0.126,
    y1: 1.437,
    x2: -0.122,
    y2: 1.437,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5252c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6954b8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5098",
    "data-name": "Rectangle 5098",
    width: 271.996,
    height: 72.979,
    fill: "#220b47"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5099",
    "data-name": "Rectangle 5099",
    width: 35.009,
    height: 43.712,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27436",
    "data-name": "Path 27436",
    d: "M138.3,189.28c-9.252.384-16.659,9.869-16.659,21.518a23.946,23.946,0,0,0,6,16.322,15.334,15.334,0,0,0,11.247,5.216,13.869,13.869,0,0,0,4.584-.776c7.306-2.5,12.665-10.844,12.665-20.761a25.953,25.953,0,0,0-1.694-9.323c-2.784-7.226-8.7-12.214-15.554-12.214-.2,0-.4,0-.591.018",
    transform: "translate(-121.639 -189.262)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.73,
    cy: 0.176,
    r: 0.343,
    gradientTransform: "matrix(1.249, 0, 0, -1.249, 1.146, 2.957)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#aea8c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#8c74b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8c74b1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27438",
    "data-name": "Path 27438",
    d: "M126.332,208.917c0,6.6,3.679,12.118,8.625,13.526,4.432-.259,10.949-4.518,10.949-13.526s-5.117-13.241-10.949-13.525c-4.946,1.406-8.625,6.931-8.625,13.525",
    transform: "translate(-126.332 -195.392)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.73,
    cy: 0.176,
    r: 0.34,
    gradientTransform: "matrix(1.382, 0, 0, -1.249, 3.223, 4.042)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#471371"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    stopColor: "#20003b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20003b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5104",
    "data-name": "Rectangle 5104",
    width: 16.754,
    height: 14.633,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5105",
    "data-name": "Rectangle 5105",
    width: 13.627,
    height: 15.778,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5106",
    "data-name": "Rectangle 5106",
    width: 35.007,
    height: 43.712,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27442",
    "data-name": "Path 27442",
    d: "M235.548,188.988c-9.253.383-16.659,9.869-16.659,21.518a23.94,23.94,0,0,0,6,16.32,15.327,15.327,0,0,0,11.247,5.216,13.868,13.868,0,0,0,4.584-.775c7.306-2.5,12.663-10.844,12.663-20.761a25.932,25.932,0,0,0-1.694-9.324c-2.783-7.226-8.7-12.212-15.553-12.212-.2,0-.4,0-.591.018",
    transform: "translate(-218.889 -188.97)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.73,
    cy: 0.176,
    r: 0.343,
    gradientTransform: "matrix(1.249, 0, 0, -1.249, 2.062, 2.977)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-35"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27444",
    "data-name": "Path 27444",
    d: "M223.582,208.625c0,6.6,3.679,12.118,8.623,13.525,4.433-.258,10.95-4.517,10.95-13.525s-5.117-13.242-10.95-13.526c-4.944,1.408-8.623,6.93-8.623,13.526",
    transform: "translate(-223.582 -195.099)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.73,
    cy: 0.176,
    r: 0.34,
    gradientTransform: "matrix(1.382, 0, 0, -1.249, 5.703, 4.074)",
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5112",
    "data-name": "Rectangle 5112",
    width: 13.628,
    height: 15.778,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27447",
    "data-name": "Path 27447",
    d: "M107.57,161.013v6.825L290.4,169.5l.86-9.2Z",
    transform: "translate(-107.57 -160.303)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.5,
    cy: 0.5,
    r: 7.067,
    gradientTransform: "matrix(0.05, 0, 0, -1, -0.727, 20.538)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#71a6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.006,
    stopColor: "#71a6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e76db"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5118",
    "data-name": "Rectangle 5118",
    width: 364.871,
    height: 304,
    fill: "#845ea2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5116",
    "data-name": "Rectangle 5116",
    width: 108.707,
    height: 57.244,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27448",
    "data-name": "Path 27448",
    d: "M24.465,241.867H128.584l3.512-57.039-8.389-.205L23.389,214.1l.192,4.965,9.976-2.654.731,18.852-10.078.048Z",
    transform: "translate(-23.389 -184.623)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -0.281,
    y1: 1.095,
    x2: -0.269,
    y2: 1.095,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9d94c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983,
    stopColor: "#994dac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#994dac"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5117",
    "data-name": "Rectangle 5117",
    width: 23.74,
    height: 10.932,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27450",
    "data-name": "Path 27450",
    d: "M46.028,209.024a140.883,140.883,0,0,0-22.639,7.252H36.617s10.222-6.389,20.879-7.915Z",
    transform: "translate(-23.389 -208.361)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 0.5,
    cy: 0.5,
    r: 1.564,
    gradientTransform: "matrix(0.232, 0, 0, -1, -0.688, 8.004)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa700"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5120",
    "data-name": "Rectangle 5120",
    width: 33.052,
    height: 12.87,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27452",
    "data-name": "Path 27452",
    d: "M88.367,218.575s-16.5,4.382-26.9,10.056H79.916s9.851-7.71,21.214-10.056Z",
    transform: "translate(-61.467 -218.575)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -2.025,
    y1: 1.823,
    x2: -1.993,
    y2: 1.823,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff6e27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.998,
    stopColor: "#e03347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e03347"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-49"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5123",
    "data-name": "Rectangle 5123",
    width: 14.936,
    height: 23.666,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27454",
    "data-name": "Path 27454",
    d: "M58.9,182.785s-5.513,0-15,7.2H60.662s3.277-7.451,7.357-9.132Z",
    transform: "translate(-43.895 -180.856)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -2.378,
    y1: 7.405,
    x2: -2.324,
    y2: 7.405,
    xlinkHref: "#linear-gradient-9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9537",
    "data-name": "Group 9537",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9423",
    "data-name": "Group 9423"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9422",
    "data-name": "Group 9422",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9421",
    "data-name": "Group 9421",
    transform: "translate(0 278.861)",
    opacity: 0.7,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9420",
    "data-name": "Group 9420"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9419",
    "data-name": "Group 9419",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27418",
    "data-name": "Path 27418",
    d: "M0,237.043s231.029,4.428,364.872-2.136L323.94,213.364,32.448,217.353Z",
    transform: "translate(0 -213.363)",
    fill: "#b589b6",
    fillRule: "evenodd"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9425",
    "data-name": "Group 9425",
    transform: "translate(72.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9424",
    "data-name": "Group 9424",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5079",
    "data-name": "Rectangle 5079",
    width: 201.982,
    height: 209.54,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9445",
    "data-name": "Group 9445"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9444",
    "data-name": "Group 9444",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9428",
    "data-name": "Group 9428",
    transform: "translate(72.079)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9427",
    "data-name": "Group 9427"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9426",
    "data-name": "Group 9426",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27420",
    "data-name": "Path 27420",
    d: "M60.069,0,143.7,2.622v9.057h-6.8l-1.3,81.213h18.251v7.476H135.6l3.76,106.8-78.136,2.377V99.494H73.09v-6.6L55.15,89.561V8.247h4.919Z",
    transform: "translate(-55.15 0)",
    fill: "#b59cc2"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9431",
    "data-name": "Group 9431",
    transform: "translate(90.02 85.231)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9430",
    "data-name": "Group 9430"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9429",
    "data-name": "Group 9429",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27421",
    "data-name": "Path 27421",
    d: "M68.877,72.873h80.754l89.026-7.662-.31,4.185L149.631,75.04l-25.639,5.208-55.115-.774Z",
    transform: "translate(-68.877 -65.212)",
    fill: "#bd406a",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9434",
    "data-name": "Group 9434",
    transform: "translate(78.149 153.421)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9433",
    "data-name": "Group 9433"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9432",
    "data-name": "Group 9432",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27422",
    "data-name": "Path 27422",
    d: "M59.793,118.915l76.245-1.529,83.044,1.529L136.2,122Z",
    transform: "translate(-59.793 -117.386)",
    fill: "#bd406a",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9437",
    "data-name": "Group 9437",
    transform: "translate(76.999 8.247)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9436",
    "data-name": "Group 9436"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9435",
    "data-name": "Group 9435",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27423",
    "data-name": "Path 27423",
    d: "M58.914,6.31l76.828,3.432H247.167l-.348,4.695L135.713,11.514Z",
    transform: "translate(-58.914 -6.31)",
    fill: "#bd406a",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9440",
    "data-name": "Group 9440",
    transform: "translate(186.443 100.369)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9439",
    "data-name": "Group 9439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9438",
    "data-name": "Group 9438",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27424",
    "data-name": "Path 27424",
    d: "M229.491,76.795l-86.838,3.814h71.3Z",
    transform: "translate(-142.652 -76.795)",
    fill: "#bd406a"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9443",
    "data-name": "Group 9443",
    transform: "translate(121.427 156.278)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9442",
    "data-name": "Group 9442"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9441",
    "data-name": "Group 9441",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27425",
    "data-name": "Path 27425",
    d: "M92.907,119.572s28.989-.114,33.269,5.756c0,0,26.828,13.685,31.746,32.821l77.846-2.142-1.845-24.958-85.4-9.716Z",
    transform: "translate(-92.907 -119.572)",
    fill: "#bd406a",
    fillRule: "evenodd"
  }))))))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9447",
    "data-name": "Group 9447",
    transform: "translate(111.928 155.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9446",
    "data-name": "Group 9446",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5087",
    "data-name": "Rectangle 5087",
    width: 177.938,
    height: 24.571,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-2)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9452",
    "data-name": "Group 9452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9451",
    "data-name": "Group 9451",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9450",
    "data-name": "Group 9450",
    transform: "translate(72.079 42.585)",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9449",
    "data-name": "Group 9449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9448",
    "data-name": "Group 9448",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27427",
    "data-name": "Path 27427",
    d: "M55.15,36.254,136.4,32.583,245.429,40.72l-.133,1.808L136.342,36.254l-77.585,1.3,77.436,8.014,108.493,5.174-.093,1.243-108.48-1.423L60.069,51.987,57.238,73.771l78.523-1.286,107.38-.907-107.4,2.193L55.15,75.228Z",
    transform: "translate(-55.15 -32.583)",
    fill: "#bd406a",
    fillRule: "evenodd"
  }))))))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9454",
    "data-name": "Group 9454",
    transform: "translate(51.93 192.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9453",
    "data-name": "Group 9453",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5090",
    "data-name": "Rectangle 5090",
    width: 205.431,
    height: 65.243,
    transform: "translate(-5.01 0)",
    fill: "url(#linear-gradient-3)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9456",
    "data-name": "Group 9456",
    transform: "translate(61.275 215.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9455",
    "data-name": "Group 9455",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5091",
    "data-name": "Rectangle 5091",
    width: 256.85,
    height: 40.149,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9463",
    "data-name": "Group 9463"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9462",
    "data-name": "Group 9462",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9461",
    "data-name": "Group 9461",
    transform: "translate(40.738 246.492)",
    opacity: 0.86,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9460",
    "data-name": "Group 9460"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9459",
    "data-name": "Group 9459",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9458",
    "data-name": "Group 9458",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9457",
    "data-name": "Group 9457",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5092",
    "data-name": "Rectangle 5092",
    width: 95.026,
    height: 47.639,
    transform: "translate(0)",
    fill: "url(#linear-gradient-4)"
  }))))))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9465",
    "data-name": "Group 9465",
    transform: "translate(40.738 246.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9464",
    "data-name": "Group 9464",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5095",
    "data-name": "Rectangle 5095",
    width: 95.025,
    height: 47.639,
    transform: "translate(0)",
    fill: "url(#linear-gradient-5)"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9467",
    "data-name": "Group 9467",
    transform: "translate(30.569 241.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9466",
    "data-name": "Group 9466",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5096",
    "data-name": "Rectangle 5096",
    width: 304.077,
    height: 57.244,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-6)"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9469",
    "data-name": "Group 9469",
    transform: "translate(46.127 191.196)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9468",
    "data-name": "Group 9468",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5097",
    "data-name": "Rectangle 5097",
    width: 288.806,
    height: 81.411,
    transform: "translate(-10.774 0.064) rotate(-1.691)",
    fill: "url(#linear-gradient-7)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9477",
    "data-name": "Group 9477"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9476",
    "data-name": "Group 9476",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9472",
    "data-name": "Group 9472",
    transform: "translate(46.129 191.196)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9471",
    "data-name": "Group 9471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9470",
    "data-name": "Group 9470",
    clipPath: "url(#clip-path-24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27434",
    "data-name": "Path 27434",
    d: "M129.757,165.315l.525,5.449,177.008,2.691v6.685l-173.062-1.6-.535,13.344-12.929-.108-.714,4.618L42.189,219.267s-15.514-38.679,0-72.979Z",
    transform: "translate(-35.295 -146.289)",
    fill: "#220b47"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9475",
    "data-name": "Group 9475",
    transform: "translate(159.389 249.26)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9474",
    "data-name": "Group 9474"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9473",
    "data-name": "Group 9473",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27435",
    "data-name": "Path 27435",
    d: "M156.961,212.572c0,12.071-7.837,21.855-17.506,21.855s-17.5-9.784-17.5-21.855,7.838-21.857,17.5-21.857,17.506,9.785,17.506,21.857",
    transform: "translate(-121.952 -190.715)",
    fill: "#9a2463",
    fillRule: "evenodd"
  }))))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9479",
    "data-name": "Group 9479",
    transform: "translate(158.979 247.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9478",
    "data-name": "Group 9478",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5101",
    "data-name": "Rectangle 5101",
    width: 34.498,
    height: 43.074,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-2)"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9481",
    "data-name": "Group 9481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9480",
    "data-name": "Group 9480",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27437",
    "data-name": "Path 27437",
    d: "M148.563,209c0,7.667-4.976,13.879-11.116,13.879a9.018,9.018,0,0,1-2.491-.353c-4.944-1.408-8.623-6.931-8.623-13.526s3.679-12.118,8.623-13.525a8.972,8.972,0,0,1,2.491-.354c6.14,0,11.116,6.212,11.116,13.879",
    transform: "translate(38.781 59.898)",
    fill: "#5a448e",
    fillRule: "evenodd"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9483",
    "data-name": "Group 9483",
    transform: "translate(165.113 255.373)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9482",
    "data-name": "Group 9482",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5103",
    "data-name": "Rectangle 5103",
    width: 19.573,
    height: 27.051,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-3)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9494",
    "data-name": "Group 9494"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9493",
    "data-name": "Group 9493",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9486",
    "data-name": "Group 9486",
    transform: "translate(161.416 247.524)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9485",
    "data-name": "Group 9485"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9484",
    "data-name": "Group 9484",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27439",
    "data-name": "Path 27439",
    d: "M140.257,189.605l-.077,7.277A11.254,11.254,0,0,0,128.6,204.02l-5.093-4.308c.094-.209.206-.416.318-.622,3.836-7.09,10.083-10.651,16.437-9.485",
    transform: "translate(-123.503 -189.387)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9489",
    "data-name": "Group 9489",
    transform: "translate(178.744 274.276)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9488",
    "data-name": "Group 9488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9487",
    "data-name": "Group 9487",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27440",
    "data-name": "Path 27440",
    d: "M150.388,211.741a23.768,23.768,0,0,1-2.052,5.177,17.812,17.812,0,0,1-9.757,8.716l-1.818-7.31s5.2-1.588,7.995-8.469Z",
    transform: "translate(-136.761 -209.855)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9492",
    "data-name": "Group 9492",
    transform: "translate(286.492 248.878)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9491",
    "data-name": "Group 9491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9490",
    "data-name": "Group 9490",
    clipPath: "url(#clip-path-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27441",
    "data-name": "Path 27441",
    d: "M254.209,212.279c0,12.071-7.837,21.855-17.5,21.855s-17.5-9.784-17.5-21.855,7.837-21.857,17.5-21.857,17.5,9.785,17.5,21.857",
    transform: "translate(-219.202 -190.423)",
    fill: "#9a2463",
    fillRule: "evenodd"
  }))))))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9496",
    "data-name": "Group 9496",
    transform: "translate(286.083 246.98)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9495",
    "data-name": "Group 9495",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5108",
    "data-name": "Rectangle 5108",
    width: 34.496,
    height: 43.073,
    fill: "url(#radial-gradient-4)"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9498",
    "data-name": "Group 9498"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9497",
    "data-name": "Group 9497",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27443",
    "data-name": "Path 27443",
    d: "M245.813,208.708c0,7.667-4.976,13.879-11.116,13.879a8.972,8.972,0,0,1-2.491-.354c-4.944-1.406-8.625-6.93-8.625-13.525s3.68-12.118,8.625-13.525a8.971,8.971,0,0,1,2.491-.354c6.14,0,11.116,6.212,11.116,13.879",
    transform: "translate(68.634 59.808)",
    fill: "#5a448e",
    fillRule: "evenodd"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9500",
    "data-name": "Group 9500",
    transform: "translate(292.217 254.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9499",
    "data-name": "Group 9499",
    clipPath: "url(#clip-path-35)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5110",
    "data-name": "Rectangle 5110",
    width: 19.573,
    height: 27.051,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-5)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9508",
    "data-name": "Group 9508"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9507",
    "data-name": "Group 9507",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9503",
    "data-name": "Group 9503",
    transform: "translate(288.518 247.142)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9502",
    "data-name": "Group 9502"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9501",
    "data-name": "Group 9501",
    clipPath: "url(#clip-path-30)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27445",
    "data-name": "Path 27445",
    d: "M237.506,189.312l-.077,7.277a11.254,11.254,0,0,0-11.584,7.137l-5.093-4.308c.094-.209.207-.416.318-.622,3.836-7.09,10.083-10.651,16.437-9.485",
    transform: "translate(-220.752 -189.094)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9506",
    "data-name": "Group 9506",
    transform: "translate(305.846 273.893)",
    style: {
      mixBlendMode: "soft-light",
      isolation: "isolate"
    }
  }, _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9505",
    "data-name": "Group 9505"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9504",
    "data-name": "Group 9504",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27446",
    "data-name": "Path 27446",
    d: "M247.637,211.448a23.769,23.769,0,0,1-2.052,5.177,17.812,17.812,0,0,1-9.757,8.716l-1.818-7.31s5.2-1.588,7.995-8.469Z",
    transform: "translate(-234.01 -209.563)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9510",
    "data-name": "Group 9510",
    transform: "translate(140.592 209.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9509",
    "data-name": "Group 9509",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5114",
    "data-name": "Rectangle 5114",
    width: 183.692,
    height: 9.201,
    transform: "translate(0)",
    fill: "url(#radial-gradient-6)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9520",
    "data-name": "Group 9520"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9519",
    "data-name": "Group 9519",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9515",
    "data-name": "Group 9515",
    transform: "translate(30.569 241.299)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9514",
    "data-name": "Group 9514"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9513",
    "data-name": "Group 9513",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9512",
    "data-name": "Group 9512",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9511",
    "data-name": "Group 9511",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5115",
    "data-name": "Rectangle 5115",
    width: 108.707,
    height: 57.244,
    fill: "url(#linear-gradient-8)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9518",
    "data-name": "Group 9518",
    transform: "translate(40.936 272.323)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9517",
    "data-name": "Group 9517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9516",
    "data-name": "Group 9516",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27449",
    "data-name": "Path 27449",
    d: "M55.061,208.361c-3.33,1.953-7.306,10.932-7.306,10.932l-16.434-.864.443-5.033,11.829-4.372Z",
    transform: "translate(-31.321 -208.361)",
    fill: "#9a2463"
  }))))))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9522",
    "data-name": "Group 9522",
    transform: "translate(30.569 272.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9521",
    "data-name": "Group 9521",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5119",
    "data-name": "Rectangle 5119",
    width: 34.107,
    height: 7.915,
    transform: "translate(0 0)",
    fill: "url(#radial-gradient-7)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9527",
    "data-name": "Group 9527"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9526",
    "data-name": "Group 9526",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9525",
    "data-name": "Group 9525",
    transform: "translate(86.947 285.672)",
    opacity: 0.5,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9524",
    "data-name": "Group 9524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9523",
    "data-name": "Group 9523",
    clipPath: "url(#clip-path-46)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27451",
    "data-name": "Path 27451",
    d: "M99.577,218.575c-1.87,1.889-1.6,5.891-1.6,5.891l-6.734-.1-7.106,2.849v4.107l-17.613.12,2.4-5.855L90.952,218.6Z",
    transform: "translate(-66.525 -218.575)",
    fill: "#9a2463"
  }))))))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9529",
    "data-name": "Group 9529",
    transform: "translate(80.336 285.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9528",
    "data-name": "Group 9528",
    clipPath: "url(#clip-path-47)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5122",
    "data-name": "Rectangle 5122",
    width: 39.663,
    height: 10.056,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-9)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9534",
    "data-name": "Group 9534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9533",
    "data-name": "Group 9533",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9532",
    "data-name": "Group 9532",
    transform: "translate(66.559 236.375)",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9531",
    "data-name": "Group 9531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9530",
    "data-name": "Group 9530",
    clipPath: "url(#clip-path-49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27453",
    "data-name": "Path 27453",
    d: "M65.861,180.856v14.517l-3.028.86-.06,5.01L51.46,204.523l-.535-4.913,4.646-1.319V182.925Z",
    transform: "translate(-50.926 -180.856)",
    fill: "#9a4f8b"
  }))))))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_9536",
    "data-name": "Group 9536",
    transform: "translate(57.37 236.375)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9535",
    "data-name": "Group 9535",
    clipPath: "url(#clip-path-50)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5125",
    "data-name": "Rectangle 5125",
    width: 24.124,
    height: 9.132,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-10)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocu);
export default __webpack_public_path__ + "static/media/Docu.9f05edaf19c832ea7682edc4bb91fbee.svg";
export { ForwardRef as ReactComponent };